import { render } from "./ErrorTransmission.vue?vue&type=template&id=9e76e93a"
import script from "./ErrorTransmission.vue?vue&type=script&lang=js"
export * from "./ErrorTransmission.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__